import { FaReact } from "react-icons/fa";
import {
  SiCss3,
  SiFirebase,
  SiHtml5,
  SiJavascript,
  SiSass,
  SiTypescript,
  SiRedux,
  SiNextdotjs,
  SiMysql,
  SiAuth0,
  SiNpm,
  SiPostgresql,
  SiMongodb,
  SiPostman,
} from "react-icons/si";

export const skillsConfig = [
  {
    icon: <SiHtml5 />,
    text: "HTML",
    color: "rgb(240, 101, 41)",
  },
  {
    icon: <SiCss3 />,
    text: "CSS",
    color: "rgb(41, 101, 241)",
  },
  {
    icon: <SiJavascript />,
    text: "JavaScript",
    color: "rgb(245, 222, 25)",
  },
  {
    icon: <SiTypescript />,
    text: "TypeScript",
    color: "rgb(45, 121, 199)",
  },
  {
    icon: <SiNextdotjs />,
    text: "Next.js",
    color: "rgb(0, 0, 0)",
  },
  {
    icon: <FaReact />,
    text: "React.js",
    color: "rgb(124, 197, 217)",
  },
  {
    icon: <SiRedux />,
    text: "Redux",
    color: "rgb(118,74,188)",
  },
  {
    icon: <SiSass />,
    text: "Sass",
    color: "rgb(204, 102, 153)",
  },
  {
    icon: <SiMongodb />,
    text: "MongoDB",
    color: "#4DB33D",
  },
  {
    icon: <SiFirebase />,
    text: "Firebase",
    color: "rgb(246,130,13)",
  },
  {
    icon: <SiMysql />,
    text: "MySQL",
    color: "rgb(0, 114, 198)",
  },
  {
    icon: <SiPostgresql />,
    text: "PostgreSQL",
    color: "#0064a5",
  },
  {
    icon: <SiPostman />,
    text: "Postman",
    color: "#ef5b25",
  },
  {
    icon: <SiAuth0 />,
    text: "Auth0",
    color: "rgb(0, 0, 0)",
  },
  {
    icon: <SiNpm />,
    text: "NPM",
    color: "rgb(203, 56, 55)",
  },
];
